import { render, staticRenderFns } from "./AFormOOI.vue?vue&type=template&id=cf13a104&scoped=true&"
import script from "./AFormOOI.vue?vue&type=script&lang=js&"
export * from "./AFormOOI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf13a104",
  null
  
)

export default component.exports